import {Appliance} from 'components/customer/Product/Appliance/entity/Appliance';

export const resolveRangehoodOpeningHeight = (
    appliance:
        Pick<Appliance, 'custom' | 'externalCode' | 'height'> | undefined,
    catalogue: Appliance[] | undefined
): number | undefined => {
    if (!appliance || appliance.custom || !catalogue?.length) {
        return typeof appliance?.height === 'number'
            ? appliance.height
            : undefined;
    }

    const matched = catalogue.find(
        (item) => item.externalCode == appliance.externalCode
    );

    if (matched && typeof matched.height === 'number') {
        return matched.height;
    }

    return typeof appliance.height === 'number' ? appliance.height : undefined;
};
